module.exports = __webpack_public_path__ + "img/old-under-maintenance.55285544.svg";